import { useState, useEffect } from "react";
import apis from '../api';

const useParamsCIR2276 = () => {
    const [params2276, setParams2276] = useState([]);
    const headers = {
        authorization: localStorage.getItem('token')
    }
    let payload = {
        CLIENT: localStorage.getItem('client'),
        ENTITY: localStorage.getItem('entity'),
        OPTION: "2"
    }
    useEffect(() => {
        const getParams = async () => {
            let parametros = [];
            let lista = [];
            await apis.getFormat2276(payload, headers).then(res => {
                parametros = res.data["SHEETS"][0]
                //console.log(parametros);
            })
            parametros["DETAIL"].forEach((row, i) => {
                lista.push({
                    VALUE: "", LABEL: row.NAME, OPTIONS: row.DETAIL, TAG: row.LABEL,
                    SHEET: parametros.NAME, SHEET_POSITION: i, POSITION: row.POSITION, TYPE: row.TYPE_NATIVE, REQUIRED: row.REQUIRED
                })
            })
            setParams2276(lista)
            console.log(lista)
        }
        getParams()
    }, []);

    return [params2276];
};

export default useParamsCIR2276;